/* src/app/modules/invoice/invoice/invoice.component.css */
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
ul {
  list-style-type: none;
}
li {
  list-style-type: none;
  margin: auto 10px;
}
.example-container {
  display: flex;
  flex-direction: column;
  min-width: 300px;
}
.example-header {
  min-height: 64px;
  padding: 8px 24px 0;
}
.mat-mdc-form-field {
  font-size: 14px;
  width: 100%;
}
.mat-mdc-table {
  overflow: auto;
  max-height: 500px;
}
.dialog-container {
  height: 500px;
  overflow: auto;
}
@media (max-width: 767px) {
  .butonera {
    display: grid;
    justify-content: start;
    grid-gap: 10px;
  }
}
.list-response-styles-e li {
  cursor: default !important;
  list-style: decimal;
  pointer-events: none;
}
.error-box {
  background: #ffe5e5;
  border: 1px solid #ff4d4d;
  padding: 10px;
  margin-top: 15px;
  color: #b30000;
  border-radius: 5px;
}
.color-factuone {
  background-color: #e3fd64;
  color: #1a1d23;
  font-weight: bold;
}
.dlg-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 48px 24px;
  color: #6b7280;
  font-size: 14px;
}
.dlg-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 14px;
  border-bottom: 1px solid #e5e7eb;
}
.dlg-hdr__title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #1a1d23;
  line-height: 1.2;
}
.dlg-hdr__icon {
  color: #e3fd64;
  font-size: 22px;
  width: 22px;
  height: 22px;
}
.dlg-hdr__sub {
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: #6b7280;
  margin-top: 1px;
}
.dlg-hdr__close {
  color: #6b7280;
  flex-shrink: 0;
}
.dlg-body {
  padding: 20px 20px 4px !important;
  max-height: 60vh;
}
.dlg-actions {
  padding: 12px 20px !important;
  border-top: 1px solid #e5e7eb;
  gap: 8px;
}
.vf-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px;
  background: #f4f6f8;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 20px;
}
.vf-qr img {
  width: 140px;
  height: 140px;
}
.vf-qr__label {
  font-size: 12px;
  color: #6b7280;
  margin: 0;
  text-align: center;
}
.vf-section__hdr {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1a1d23;
  margin-bottom: 12px;
}
.vf-section__hdr mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #6b7280;
}
.vf-events {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  border-left: 2px solid #e5e7eb;
  padding-left: 16px;
}
.vf-events__item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 0;
  font-size: 13px;
  color: #374151;
  position: relative;
  margin-left: -21px;
  padding-left: 21px;
  list-style: none;
}
.vf-events__dot {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e3fd64;
  border: 2px solid #fff;
  outline: 2px solid #e3fd64;
  margin-top: 3px;
  position: absolute;
  left: -5px;
}
.vf-events__text {
  line-height: 1.5;
}
.vf-empty {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #6b7280;
  padding: 12px;
  background: #f4f6f8;
  border-radius: 6px;
  margin: 0;
}
.vf-empty mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #9ca3af;
}
.fe-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.5;
  margin-bottom: 16px;
}
.fe-notice--warn {
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #92400e;
}
.fe-notice--warn mat-icon {
  color: #d97706;
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  margin-top: 1px;
}
.fe-section {
  margin-bottom: 16px;
}
.fe-section__title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .05em;
  color: #6b7280;
  margin-bottom: 8px;
}
.fe-section__title mat-icon {
  font-size: 15px;
  width: 15px;
  height: 15px;
}
.fe-errors {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.fe-errors li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 13px;
  color: #374151;
  padding: 7px 10px;
  background: #fef2f2;
  border-left: 3px solid #dc2626;
  border-radius: 0 4px 4px 0;
  list-style: none;
  margin: 0;
}
.fe-errors li::before {
  content: "\2022";
  color: #dc2626;
  font-weight: 700;
  flex-shrink: 0;
}
.fe-options {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 20px;
}
.fe-option {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  background: #f9fafc;
  cursor: default;
}
.fe-option__hint {
  font-size: 12px;
  color: #6b7280;
  margin-left: 32px;
  line-height: 1.4;
}
.fe-cert {
  padding: 16px;
  background: #f4f6f8;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.fe-cert__title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1a1d23;
  margin-bottom: 14px;
}
.fe-cert__title mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
  color: #e3fd64;
}
.fe-file-wrap {
  margin-bottom: 12px;
}
.fe-file-input {
  display: none;
}
.fe-file-label {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border: 1.5px dashed #d1d5db;
  border-radius: 6px;
  background: #fff;
  font-size: 13px;
  color: #6b7280;
  cursor: pointer;
  transition: border-color .15s, background .15s;
  width: 100%;
  box-sizing: border-box;
}
.fe-file-label:hover {
  border-color: #e3fd64;
  background: #f9ffe0;
  color: #4d7a00;
}
.fe-file-label mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.fe-password {
  width: 100%;
}
.pd-body {
  padding: 0 !important;
  max-height: calc(90vh - 130px) !important;
}
.pd-remaining {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 24px;
  background:
    linear-gradient(
      135deg,
      #fff8e6 0%,
      #fff4d6 100%);
  border-bottom: 1px solid #f4fec1;
}
.pd-remaining__left {
  display: flex;
  align-items: center;
  gap: 12px;
}
.pd-remaining__left > mat-icon {
  font-size: 28px;
  width: 28px;
  height: 28px;
  color: #e3fd64;
  flex-shrink: 0;
}
.pd-remaining__label {
  display: block;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: #92400e;
}
.pd-remaining__amount {
  display: block;
  font-size: 22px;
  font-weight: 700;
  color: #1e2235;
  line-height: 1.2;
}
.pd-remaining__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.pd-section {
  padding: 20px 24px 4px;
  border-bottom: 1px solid #f0f0f0;
}
.pd-section:last-child {
  border-bottom: none;
}
.pd-section__title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: .05em;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
}
.pd-section__title mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #e3fd64;
}
.pd-suffix {
  font-size: 14px;
  color: #6b7280;
}
/*# sourceMappingURL=invoice.component.css.map */
